import React from "react"; 
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import { AuthProvider } from '@app/contexts/AuthContext.jsx';

import ProtectedRoute from "@app/guards/ProtectedRoute";
import HomeTemplate from "@app/components/5_pages/HomeTemplate";
import Offline from "@app/components/4_templates/Offline";
import LayoutApp from "@app/components/4_templates/LayoutApp";
import ToastContainer from "@app/components/3_modules/ToastContainer";
import SessionNew from "@app/components/5_pages/session/SessionNew";
import PasswordResetNew from "@app/components/5_pages/password_reset/PasswordResetNew";
import PasswordResetEdit from "@app/components/5_pages/password_reset/PasswordResetEdit";
import SettingLoader from "@app/components/3_modules/SettingLoader";
import Home from "@app/components/5_pages/Home";
import CustomerEdit from "@app/components/5_pages/customers/CustomerEdit";

export default (     
    <AuthProvider>        
        <ToastContainer>
            <SettingLoader>
                <BrowserRouter>
                    <Routes>
                        <Route element={<Offline />}>
                            <Route path="/sign-in" element={<SessionNew />}></Route>
                            <Route path="/forgot-password" element={<PasswordResetNew />}></Route>
                            <Route path="/reset-password/:reset_token/edit" element={<PasswordResetEdit />}></Route> 
                        </Route>
                        {/** Example part */}
                        <Route element={<LayoutApp />}>
                            <Route path="/template" element={<HomeTemplate />}></Route>                            
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={["all"]} />}>
                            <Route element={<LayoutApp />}>
                                <Route path="/" element={<Home />}></Route>
                                <Route path="/customers/:id" element={<CustomerEdit />}></Route>
                            </Route>
                        </Route>
                    </Routes>
                </BrowserRouter>    
            </SettingLoader>    
        </ToastContainer>
    </AuthProvider>    
); 

//TvyOtLWOPMGfrepY3IrUvg